import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {AgendaEventSummaryModel} from '../agendaEventSummary.model';
import {DateConverter} from '../../../../../../common/converter/date.converter';
import {PartnerSummaryConverter} from '../../../../../../partner/common/api/converter/partnerSummary.converter';
import {AgendaEventAutoGeneratedLabelConverter} from './agendaEventAutoGeneratedLabel.converter';
import {Injectable} from '@angular/core';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {UserSummaryConverter} from '../../../../../../account/modules/user/api/converter/userSummary.converter';
import {AgendaCalendarSummaryConverter} from "../../../../calendar/api/converter/agendaCalendarSummary.converter";
import {AgendaCategorySummaryConverter} from "../../../../category/api/converter/agendaCategorySummary.converter";

@Injectable({
    providedIn: 'root',
})
export class AgendaEventSummaryConverter extends HttpModelConverter<AgendaEventSummaryModel>{
    constructor(private agendaCalendarConverter: AgendaCalendarSummaryConverter,
                private agendaCategoryConverter: AgendaCategorySummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,
                private userSummaryConverter: UserSummaryConverter,
                private partnerSummaryConverter: PartnerSummaryConverter) {
        super();
    }

    protected createInstance(): AgendaEventSummaryModel {
        return new AgendaEventSummaryModel();
    }

    protected enrichObject(result: AgendaEventSummaryModel, src: AgendaEventSummaryModel) {
        const dateConverter = new DateConverter();
        result.category = this.agendaCategoryConverter.convert(src.category) ;
        result.partner = this.partnerSummaryConverter.convert(src.partner);
        result.start = dateConverter.convert(src.start);
        result.end = dateConverter.convert(src.end);
        result.autoGeneratedLabel = new AgendaEventAutoGeneratedLabelConverter().convert(src.autoGeneratedLabel);
        result.calendars = this.agendaCalendarConverter.convertFromArray(src.calendars);
        result.cancellationType = this.lovValueSummaryConverter.convert(src.cancellationType);
        result.responsible = this.userSummaryConverter.convert(src.responsible);
        result.cancelledUser = this.userSummaryConverter.convert(src.cancelledUser);
    }
}
